import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import AvailabilityDisplay from "./availabilityDisplay";
import EditAvailability from "./editAvailability";
import useAvailability from "./useAvailability";
import { scrollIntoView } from "utils/helper";

function Availability({ isShowEditIcon = true }) {
  const [t] = useTranslation();
  const [isEditMode, setIsEditMode] = useState(false);
  const { onEditSave, isLoading } = useAvailability();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("availabilityScrollId");
  };

  const handleSave = async (values) => {
    await onEditSave(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditAvailability
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <AvailabilityDisplay
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

Availability.propTypes = {
  isShowEditIcon: PropTypes.bool,
};

export default Availability;
